import {
  NodePanelProps,
  PanelContainer,
} from "../../lib/panel/panel-container";
import { PanelWebhook } from "./panel-webhook";

export function WebhookActionNodePanel(props: NodePanelProps<any>) {
  return (
    <PanelContainer nodeProps={props}>
      <PanelWebhook />
    </PanelContainer>
  );
}
